// AUTH-05 Forgot password. Also how an account that never had a password sets its first one.
import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Button, Form } from "react-aria-components";
import { api, call } from "../../api/client";
import { describeError } from "../../api/errors";
import { Banner } from "../../components/Banner";
import { AuthLayout } from "./AuthLayout";
import { Field } from "./fields";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit() {
    setBusy(true);
    setError(null);
    try {
      await call(api.POST("/auth/password/forgot", { body: { email } }));
      setSent(true);
    } catch (err) {
      setError(describeError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout title="Set or reset your password" footer={<Link to="/sign-in">Back to sign in</Link>}>
      {sent ? (
        <Banner>If an account uses {email}, we've sent it a link to set a new password. The link works for one hour.</Banner>
      ) : (
        <>
          <p>Enter your email and we'll send you a link to choose a password. This also works if you've never had one.</p>
          {error && <Banner tone="critical">{error}</Banner>}
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              void submit();
            }}
          >
            <Field label="Email" type="email" name="email" autoComplete="username" isRequired value={email} onChange={setEmail} autoFocus />
            <Button type="submit" className="button primary wide" isPending={busy}>
              Send link
            </Button>
          </Form>
        </>
      )}
    </AuthLayout>
  );
}
